import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "sonner";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <Toaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        className: "ld-toast",
        style: {
          fontFamily: "Manrope, ui-sans-serif, system-ui",
          borderRadius: "14px",
        },
      }}
    />
  </>
);
